import cn from 'classnames';
import {ChangeEvent, Dispatch, SetStateAction} from 'react';
import {useQueryClient} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import useGetAvailableLoanTypes from '../../../../services/hookService/getAvailableLoanTypes/useGetAvailableLoanTypes';

import usePostDirectLoanRequest from '../../../../services/hookService/postDirectLoanRequest/usePostDirectLoanRequest';
import usePostLoanRequest from '../../../../services/hookService/postLoanRequest/usePostLoanRequest';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

type RequestType = 'loan' | 'credit';

const SelectRequestTypeBtm = ({isOpen, setIsOpen}: IProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {data: availableLoanTypes, isLoading: isAvailableLoanTypesLoading} =
    useGetAvailableLoanTypes(isOpen);

  const {mutate: postLoanRequest, isLoading: isLoadingPostLoanRequest} =
    usePostLoanRequest();
  const {mutate: postDirectLoan, isLoading: isLoadingDirectLoan} =
    usePostDirectLoanRequest();

  const handleSuccess = async (path: string) => {
    await queryClient.invalidateQueries({
      queryKey: ['listLoanRequest'],
    });
    window.location.replace(path);
  };

  const handleSelectRequestType = (e: ChangeEvent<HTMLInputElement>) => {
    const requestType = e.target.value as RequestType;

    if (requestType === 'loan') {
      postDirectLoan(undefined, {
        onSuccess: res => {
          if (res.status === 201) {
            void handleSuccess('/receive-loan/step-1');
          }
        },
      });
    }

    if (requestType === 'credit') {
      postLoanRequest(undefined, {
        onSuccess: res => {
          if (res.status === 201) {
            void handleSuccess('/receive-credit/step-1');
          }
        },
      });
    }
  };

  const isLoading =
    isLoadingPostLoanRequest ||
    isLoadingDirectLoan ||
    isAvailableLoanTypesLoading;

  return (
    <BottomSheet
      open={isOpen}
      blocking
      onDismiss={() => setIsOpen(false)}
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-2 p-6 CalenderWrapperBottomSheet-wrapper">
        <i
          className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
          onClick={() => setIsOpen(false)}
        />

        <p className="text-lg font-bold text-center text-gray-950">
          نوع اعتبار
        </p>

        <div
          className={cn(
            'flex flex-col gap-3',
            isLoading && 'animate-pulse pointer-events-none',
          )}
        >
          <fieldset
            className="disabled:opacity-50 disabled:pointer-events-none"
            disabled={!availableLoanTypes?.has_available_direct_loan_type}
          >
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                <input
                  id="loan-type-loan"
                  type="radio"
                  name="requestType"
                  value="loan"
                  onChange={handleSelectRequestType}
                  className="accent-farm-shop-500"
                />
                <label htmlFor="loan-type-loan">دریافت وام</label>
              </div>
              <span className="text-sm text-gray-600">
                واریز وجه به حساب کاربر و خرید با پیش پرداخت
              </span>
            </div>
          </fieldset>

          {/* Disabled receive credit for now */}
          <fieldset
            disabled={!availableLoanTypes?.has_available_credit_loan_type}
            className="disabled:opacity-50 disabled:pointer-events-none"
          >
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                <input
                  id="loan-type-credit"
                  type="radio"
                  name="requestType"
                  value="credit"
                  onChange={handleSelectRequestType}
                  className="accent-farm-shop-500"
                />
                <label htmlFor="loan-type-credit">دریافت اعتبار</label>
              </div>
              <span className="text-sm text-gray-600">
                واریز وجه بصورت اعتبار در حساب مزرعه
              </span>
            </div>
          </fieldset>
        </div>
      </div>
    </BottomSheet>
  );
};

export default SelectRequestTypeBtm;
